import type { Ionicons } from '@expo/vector-icons';

type IconName = keyof typeof Ionicons.glyphMap;

// The Content API returns amenities as plain strings grouped by category
// (AmenityGroup.amenities: string[]) — no icon field anywhere in the
// schema. This is a client-side keyword match, not sourced from the API.
const AMENITY_ICON_RULES: { keywords: string[]; icon: IconName }[] = [
  { keywords: ['wifi', 'internet'], icon: 'wifi-outline' },
  { keywords: ['pool'], icon: 'water-outline' },
  { keywords: ['fitness', 'gym'], icon: 'barbell-outline' },
  { keywords: ['front desk', 'reception'], icon: 'time-outline' },
  { keywords: ['air conditioning', 'ac '], icon: 'snow-outline' },
  { keywords: ['parking'], icon: 'car-outline' },
  { keywords: ['garden'], icon: 'leaf-outline' },
  { keywords: ['non-smoking', 'smoke-free'], icon: 'ban-outline' },
  { keywords: ['smoking area', 'designated smoking'], icon: 'flame-outline' },
  { keywords: ['restaurant', 'dining'], icon: 'restaurant-outline' },
  { keywords: ['bar', 'lounge'], icon: 'wine-outline' },
  { keywords: ['spa'], icon: 'flower-outline' },
  { keywords: ['pet'], icon: 'paw-outline' },
  { keywords: ['room service'], icon: 'bicycle-outline' },
  { keywords: ['shuttle', 'airport'], icon: 'bus-outline' },
  { keywords: ['business'], icon: 'briefcase-outline' },
  { keywords: ['laundry'], icon: 'shirt-outline' },
  { keywords: ['elevator', 'lift'], icon: 'swap-vertical-outline' },
  { keywords: ['breakfast'], icon: 'cafe-outline' },
  { keywords: ['beach'], icon: 'sunny-outline' },
];

const FALLBACK_ICON: IconName = 'checkmark-circle-outline';

export function getAmenityIcon(label: string): IconName {
  const normalized = label.toLowerCase();
  const match = AMENITY_ICON_RULES.find((rule) => rule.keywords.some((keyword) => normalized.includes(keyword)));
  return match?.icon ?? FALLBACK_ICON;
}
